module.exports = __webpack_public_path__ + "static/media/c5e783c5-cc20-42db-8507-85ebd7895373.057f5e84.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/c5e783c5-cc20-42db-8507-85ebd7895373.jpg
// module id = 850
// module chunks = 0